<div *ngIf="params?.data?.isExpandable" class="container-fluid pt-1 w-100 px-0 main-container-div">
  <div class="row" style="--bs-gutter-x: 0.1rem !important;">
    <div class="col-12 px-0 br-top custom-bg">
      <div class="tableFixHead ">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="pt-1 pb-0 text-start">Type</th>
              <th *ngIf="params?.data?.voucherType=='Payment Voucher'" scope="col" class="pt-1 pb-0 text-start">Transfer
                From</th>
              <th *ngIf="params?.data?.voucherType=='Receipt Voucher'" scope="col" class="pt-1 pb-0 text-start">Deposit
                Into</th>
              <th scope="col" class="pt-1 pb-0 text-end">Against</th>
              <th scope="col" class="pt-1 pb-0 text-end">Transaction No.</th>
              <th scope="col" class="pt-1 pb-0 text-end">Transaction Dt.</th>
              <th scope="col" class="pt-1 pb-0 text-end">Amount</th>
              <th scope="col" class="pt-1 pb-0 text-end">Comment</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of voucherDetails" style="line-height: 1.5;">
              <td class="pt-0 pb-1 text-start">{{item.paymentTypeName ? item.paymentTypeName : "_" }}</td>
              <td *ngIf="params?.data?.voucherType=='Payment Voucher'" class="pt-0 pb-1 text-start">{{item.transferName
                ? item.transferName: "_"}}</td>
              <td *ngIf="params?.data?.voucherType=='Receipt Voucher'" class="pt-0 pb-1 text-start">{{item.depositeIntoName ?
                item.depositeIntoName: "_"}}</td>
              <td class="pt-0 pb-1 text-end">{{item.againstName ? item.againstName : "_"}}</td>
              <td class="pt-0 pb-1 text-end">{{item.transactionNo ? item.transactionNo : "_"}}</td>
              <td class="pt-0 pb-1 text-end">{{ item.transactionDate ? (item.transactionDate | date:'MM-dd-yyyy'):"_" }}</td>
              <td class="pt-0 pb-1 text-end">{{item.amount ? item.amount : "0.00"}}</td>
              <td class="pt-0 pb-1 text-end">{{item.comment ? item.comment : "0.00"}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>